import React from "react";
import {Box} from "@chakra-ui/react";
import Overview from "./bookingDetailsOverview.jsx";

const BookingDetailsTabList = [
  {
    label: () => {
      return <Box fontSize={"20px"}>Overview</Box>;
    },
    component: Overview,
  },
];

export default BookingDetailsTabList;
